<template>
  <Card size="medium" variant="tertiary">
    <View direction="column" gap="md">
      <Text variant="h5">Dialog highlights</Text>
      <View direction="column" gap="sm">
        <View v-for="(highlight, index) in highlights" :key="index" direction="row" gap="xs" align="start">
          <Text variant="body-medium">• {{ highlight }}</Text>
        </View>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, View } from '@tallo/design-system';

defineProps<{ highlights: string[] }>();
</script>

<style scoped lang="scss"></style>
